import { Card, CardFooter, Col, Form } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { EditProfile, UpdateProfile } from "../../../../Constant";
import { EditProfileFormBody } from "./EditProfileFormBody";

const EditProfileForm = () => {
  return (
    <Col xl="8">
      <Form onSubmit={(event) => event.preventDefault()}>
        <Card>
          <CommonCardHeader title={EditProfile} />
          <EditProfileFormBody />
          <CardFooter className="text-end">
            <Btn color="primary">{UpdateProfile}</Btn>
          </CardFooter>
        </Card>
      </Form>
    </Col>
  );
};

export default EditProfileForm;
